import { useImporterTheme } from '@shared/components/csv-importer/useImporterTheme';
import { FC } from 'react';
import { ReactSpreadsheetImport } from 'react-spreadsheet-import';
import { Result } from 'react-spreadsheet-import/types/types';
import { useGetCleanupMixedFields } from '../fields';
import { GoodsImportData, GoodsImportRow } from '../types';
import { useMixedRowValidator } from '../utils';

interface CsvImporterGoodsProps {
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: (rows: GoodsImportData, file: File) => Promise<void>;
  excludeDate?: boolean;
  excludeSite?: boolean;
  excludeSupplier?: boolean;
  includeCustomer?: boolean;
  excludeTotalSpend?: boolean;
}

const CsvImporterGoods: FC<CsvImporterGoodsProps> = ({
  isOpen,
  onClose,
  handleSubmit,
  excludeDate = false,
  excludeSite = false,
  excludeSupplier = false,
  includeCustomer = false,
  excludeTotalSpend = false,
}: CsvImporterGoodsProps) => {
  const theme = useImporterTheme();

  const onSubmit = async (data: Result<keyof GoodsImportRow>, file: File) =>
    handleSubmit(data.validData, file);

  return (
    <ReactSpreadsheetImport<keyof GoodsImportRow>
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      fields={useGetCleanupMixedFields({
        excludeDate,
        excludeSite,
        excludeSupplier,
        includeCustomer,
        excludeTotalSpend,
      })}
      autoMapSelectValues
      allowInvalidSubmit={false}
      rowHook={useMixedRowValidator()}
      customTheme={theme}
      isNavigationEnabled
      // SheetJS number format applied when stringifying Excel date cells. Must
      // produce a string our date parsing (parseUKDate) accepts, or every date
      // cell in an upload is silently dropped.
      dateFormat="dd/mm/yyyy"
      uploadStepHook={async (data) => {
        if (data.length > 100001) {
          onClose();
          throw new Error(
            'Data limit exceeded: Maximum of 100,000 rows allowed.'
          );
        }
        return data;
      }}
    />
  );
};

export default CsvImporterGoods;
